import { CheckCircle2, AlertCircle, Info, X } from 'lucide-react';

export type ToastKind = 'success' | 'error' | 'info';

const tone: Record<ToastKind, { bg: string; icon: typeof Info }> = {
  success: { bg: 'bg-[var(--color-green-tint)]', icon: CheckCircle2 },
  error: { bg: 'bg-[var(--color-red-tint)]', icon: AlertCircle },
  info: { bg: 'bg-[var(--color-blue-tint)]', icon: Info },
};

export function Toast({
  kind,
  text,
  onClose,
}: {
  kind: ToastKind;
  text: string;
  onClose: () => void;
}) {
  const { bg, icon: Icon } = tone[kind];
  return (
    <div
      role="status"
      className={[
        'flex items-center gap-3 pl-3 pr-2 py-2',
        'rounded-[var(--radius-sm)] shadow-[var(--shadow-md)]',
        'border border-[var(--color-border)]',
        bg,
      ].join(' ')}
    >
      <Icon size={18} strokeWidth={1.5} />
      <span className="text-sm flex-1">{text}</span>
      <button
        type="button"
        onClick={onClose}
        aria-label="Закрыть"
        className="h-6 w-6 rounded-[var(--radius-xs)] inline-flex items-center justify-center hover:bg-black/5"
      >
        <X size={14} strokeWidth={1.5} />
      </button>
    </div>
  );
}
